window.toggleSearch = function(button) {
    let classicSearch = document.querySelector('.js-classic-search');
    let advancedSearch = document.querySelector('.js-advanced-search');

    if(classicSearch.classList.contains('hidden')) {
        classicSearch.classList.remove('hidden');
        advancedSearch.classList.add('hidden');

        button.innerHTML = "Rozšířené vyhledávání";
    }
    else {
        classicSearch.classList.add('hidden');
        advancedSearch.classList.remove('hidden');

        button.innerHTML = "Skrýt rozšířené vyhledávání";
    }
};